import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled } from '@mui/material/styles';
const StyledPaper = styled('section') `
  ${({ isTournamentTableView }) => isTournamentTableView ? {
    display: 'grid',
    gridTemplateColumns: '80px 1fr 300px auto 160px',
} : {}};
  ${({ isTournamentTableViewV2 }) => isTournamentTableViewV2 ? {
    display: 'grid',
    gridTemplateColumns: '1fr 18% 12% minmax(120px, auto) 14%',
} : {}};
  box-shadow: 0px 4px 8px 1px rgba(0, 0, 0, 0.05);
  background-color: ${(props) => props.theme.palette.common.white};
  border-radius: 4px;
`;
const SectionContainer = ({ children, className = '', 'data-testid': testID, isTournamentTableView, isTournamentTableViewV2 }) => {
    return (_jsx(StyledPaper, { isTournamentTableView: isTournamentTableView, isTournamentTableViewV2: isTournamentTableViewV2, className: className, "data-testid": testID, children: children }));
};
export default SectionContainer;
